export const PageDataState = {
    Searchs: {
        supply_hr_id: {
            type: 'text',
            id: 'supply_hr_id',
            label: '',
            value: '',
            placeholder: ''
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            placeholder: 'อุตสาหกรรม'
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        supply_hr_id: {
            type: 'select',
            id: 'supply_hr_id',
            label: 'สาขางาน',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },                                   
    },
    InputGroup: {}
}